import { LS_RECENT_CONVERSATION_ACTIVITY_KEY } from '@atlassian/conversation-assistant-utils/nonEssentialLocalStorage/nonEssentialLocalStorageKeys';

/** Returns the site-scoped key for the versioned recent-conversation activity association. */
export const getRecentConversationActivityKey = (siteId: string): string =>
	siteId ? `${LS_RECENT_CONVERSATION_ACTIVITY_KEY}_${siteId}` : LS_RECENT_CONVERSATION_ACTIVITY_KEY;
